import axios from 'axios';
import { config } from 'Constants';

/**
 * @desc for given id, it post customer call
 * @return promise - axios returns a promise
 */
export const getCalls = (query) => {
	const user = JSON.parse(localStorage.getItem('user'));
	const headers = {
		'Content-Type': 'application/json',
		Authorization: user.token,
	};
	const url = `${config.url.API_URL}/api/general/call?${query}`;
	return axios.get(url, { headers });
};

/**
 * @desc for given id, it post customer call
 * @return promise - axios returns a promise
 */
export const postCall = (data) => {
	const user = JSON.parse(localStorage.getItem('user'));
	const headers = {
		'Content-Type': 'application/json',
		Authorization: user.token,
	};
	const url = `${config.url.API_URL}/api/general/call`;
	return axios.post(url, data, { headers });
};
